import React from 'react';
import {
  Typography,
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@mui/material';

/**
 * Shared cookie category checklists for CookieConsent and CookiePreferencesManager.
 */
export default function CookiePreferencesFields({ preferences, onPreferenceChange }) {
  return (
    <>
      <Typography variant="body2" paragraph>
        You can enable or disable certain types of cookies. Essential cookies are necessary for the site to function and cannot be disabled.
      </Typography>

      <FormGroup>
        <FormControlLabel
          control={(
            <Checkbox
              checked={preferences.essential}
              disabled
              name="essential"
            />
          )}
          label={(
            <Box>
              <Typography variant="subtitle2">Essential Cookies</Typography>
              <Typography variant="caption" color="text.secondary">
                Required for the website to function properly. Always active.
              </Typography>
            </Box>
          )}
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={preferences.analytics}
              onChange={onPreferenceChange}
              name="analytics"
            />
          )}
          label={(
            <Box>
              <Typography variant="subtitle2">Analytical Cookies</Typography>
              <Typography variant="caption" color="text.secondary">
                Help us improve the site by collecting and analyzing information about its use.
              </Typography>
            </Box>
          )}
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={preferences.functional}
              onChange={onPreferenceChange}
              name="functional"
            />
          )}
          label={(
            <Box>
              <Typography variant="subtitle2">Functional Cookies</Typography>
              <Typography variant="caption" color="text.secondary">
                Allow us to remember your settings and preferences to make your site experience more convenient.
              </Typography>
            </Box>
          )}
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={preferences.targeting}
              onChange={onPreferenceChange}
              name="targeting"
            />
          )}
          label={(
            <Box>
              <Typography variant="subtitle2">Marketing Cookies</Typography>
              <Typography variant="caption" color="text.secondary">
                Used to display relevant advertisements and track their effectiveness.
              </Typography>
            </Box>
          )}
        />
      </FormGroup>
    </>
  );
}
